<script>
	import {translate} from "../utils/translations";
</script>

<button type="button" class="addAddressButton" on:click>
	<span class="addAddressButton-icon" />
	<span class="addAddressButton-text">{translate('app.checkout.address.add')}</span>
</button>
